import React, { Component } from 'react';

import { setPageTitle } from 'modules/layout/layout.actions';
import { connect } from 'react-redux';

import { withRouter } from 'react-router-dom';
import { getClientSettings } from './estimator.actions';
import FullscreenSpinner from 'common/fullscreenSpinner.component';
import EstimatesTableComponent from './estimatesTable.component';
import CostEstimatorContainer from './costEstimator.container';

class Estimates extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
    };

    this.fetchData = this.fetchData.bind(this);
  }

  fetchData = async () => {
    this.setState({ isLoading: true });

    await this.props.getClientSettings();

    this.setState({ isLoading: false });
  }

  componentDidMount() {
    this.props.setPageTitle('My Estimates');

    this.fetchData();
  }

  render() {
    const { clientSettings } = this.props;
    const { isLoading } = this.state;

    return (
      <>
        {!isLoading && clientSettings && clientSettings.isPremium && (
          <EstimatesTableComponent />
        )}
        {!isLoading && (!clientSettings || (clientSettings && !clientSettings.isPremium)) && (
          <CostEstimatorContainer />
        )}
        {isLoading && (
          <FullscreenSpinner />
        )}

      </>
    );
  }
}

const mapStateToProps = (state) => {
    return {
      clientSettings: state.estimator.get('clientSettings'),
    };
};
  
export default withRouter(connect(mapStateToProps, {
    setPageTitle,
    getClientSettings
})(Estimates));
